import styled from 'styled-components';

import { SecondaryButton } from '../../../components';
import { ThemeProp } from '../../../theme/Themes';
import AuthenticatedLayout from '../../layouts/AuthenticatedLayout/AuthenticatedLayout';
import { LeftContainer, NavigationContainer } from '../../settings/ProfilePage/ProfilePage.styles';

export const StyledAuthenticatedLayout = styled(AuthenticatedLayout)`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 3.75rem 1rem 0 1rem;
    background-color: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    height: auto;
  }
`;

export const StyledNavigationContainer = styled(NavigationContainer)`
  margin-top: 0rem;
`;

export const StyledLeftContainer = styled(LeftContainer)`
  @media (min-width: ${(props: any) => props.theme.breakpoints.desktop}) {
    padding: 0.75rem 0.875rem !important;
  }

  @media (max-width: ${(props: any) => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const NotificationsSectionTitle = styled.span`
  display: flex;
  font-weight: ${(props) => props.theme.fontWeight.medium};
  font-size: ${(props) => props.theme.fontSize.l};
  line-height: ${(props) => props.theme.fontWeight.l};
  margin-bottom: 2rem;

  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const NotificationsList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1rem;
  overflow: scroll;
`;

export const StyledSencondaryButton = styled(SecondaryButton)`
  display: flex;
  flex-direction: column;
  width: 122px;
  margin-left: auto;
`;

export const NotificationListHeader = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 1rem;
  align-items: center;
`;

export const Label = styled.span`
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: ${(props) => props.theme.fontSize.xs};
  color: ${(props) => props.theme.colors.greyscale.c600};
`;

export const UnclickedContainer = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 0.5rem;
  width: 0.5rem;
  position: absolute;
  right: 0;
  top: 0.5rem;
  box-sizing: content-box;
  padding: 1rem;
  cursor: pointer;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding-right: 0.5rem;
  }
`;

export const UnclickedIndicator = styled.div`
  background: ${(props: ThemeProp) => props.theme.colors.main.c600};
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    border-radius: 50%;
  }
`;

export const SectionHeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    margin-bottom: 1.5rem;
    display: none;
  }
`;

export const StyledDiv = styled.div`
  position: relative;
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.system.error};
  font-weight: ${(props) => props.theme.fontWeight.semibold};
  font-size: ${(props) => props.theme.fontSize.xxs};
  margin-left: auto;
  width: 26px;
  height: 20px;
  border-radius: 40px;
`;
